// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1GoJI","left":"InfoRow_left__1Jct0"};